import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronDownWhite = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 8,
	viewBox: "0 0 14 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.78033 7.28033C7.48744 7.57322 7.01256 7.57322 6.71967 7.28033L0.71967 1.28033C0.426776 0.987438 0.426776 0.512564 0.71967 0.219671C1.01256 -0.073222 1.48744 -0.073222 1.78033 0.219671L7.25 5.68934L12.7197 0.21967C13.0126 -0.073223 13.4874 -0.0732231 13.7803 0.21967C14.0732 0.512563 14.0732 0.987437 13.7803 1.28033L7.78033 7.28033Z",
		fill: "white"
	})
});
export default SvgChevronDownWhite;
